import { createSlice } from "@reduxjs/toolkit";

const loadInitialState = () => {
  const storedState = localStorage.getItem("authState");
  if (storedState) {
    return JSON.parse(storedState);
  }
  return {};
};

const initialState = loadInitialState();

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuthData: (state, action) => {
      const { auth_token, userId, telegramId } = action.payload;
      state.auth_token = auth_token;
      state.userId = userId;
      state.telegramId = telegramId;

      localStorage.setItem("authState", JSON.stringify(state));
      localStorage.setItem("auth_token", auth_token);
    },
    setAuthToken: (state, action) => {
      state.auth_token = action.payload;
      const stored = JSON.parse(localStorage.getItem("authState")) || {};
      const newState = { ...stored, auth_token: action.payload };
      localStorage.setItem("authState", JSON.stringify(newState));

      localStorage.setItem("auth_token", action.payload);
    },
    clearAuthData: (state) => {
      state.auth_token = null;
      state.userId = null;
      state.telegramId = null;

      localStorage.removeItem("authState");
      localStorage.removeItem("auth_token");
    },
  },
});

export const { setAuthData, clearAuthData, setAuthToken } = authSlice.actions;
export default authSlice.reducer;
